import GotoPage from '../gotoPage';
import css from './index.module.scss';
import FeatApp from './components/feat-app';
import { useGlobal } from '@/utils/useGlobal';
import EFDelta2Replay from '@/components/UI/svg/Delta2/Icon/EFDelta2Replay';
import { createEFPic } from '@/utils/useEFPic';
import EFVideo from '@/components/UI/EFVideo';

const { EFPic } = createEFPic('/media/delta2/h5/');
export default function SectionTwo({}: any) {
    const { useLang, useEffect, useState, useRouter, useRef } = useGlobal();
    const { t } = useLang('delta2portablepowerstation');
    const { locale } = useRouter();
    const videoRef = useRef(null);
    const [isEnter, setIsEnter] = useState(false);
    const layoutH = typeof window !== 'undefined' ? window.innerHeight : 1042;

    const replayVideo = () => videoRef.current?.play();

    useEffect(() => {
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: '.ThreeVideo', //触发元素
            offset: layoutH, // //从开始点滚动多少px触发,可为负数
            triggerHook: 0, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: '200%', //和滚动条绑定到一起,场景持续滚动距离为 800px
        });
        sceneA1.on('enter', function () {
            setIsEnter(true);
        });
        sceneA1.on('leave', function () {
            setIsEnter(false);
        });
        // @ts-ignore window.controllerDelta2
        controllerDelta2?.addScene(sceneA1);
    }, []);

    return (
        <div className={`${css.ThreeVideo} ThreeVideo GtmModuleData-section`} data-section-id={css.ThreeVideo} data-section-title={t('delta2.aniI_msg5')}>
            <div className={locale === 'jp' || locale === 'fr' ? 'jp-fill' : ''}>
                <div className="s-box">
                    <EFVideo className="video replayvideo" ref={videoRef} loop={false} sources={['/video/delta2-h5/BMS.webm', '/video/delta2-h5/BMS.mp4']} />
                    <div className="f-img" onClick={() => replayVideo()}>
                        <EFDelta2Replay />
                    </div>
                    <div className="f-text">
                        <div className="f-title">{t('delta2.aniI_msg5')}</div>
                        <div className="f-des">{t('delta2.aniI_msg6')}</div>
                    </div>
                </div>
                <div className="deltaPros-out">
                    <div className="ef-scroll-ani-total-box">
                        <div className="ef-scroll-ani">
                            <div className="ef-scroll-ani-trigger">
                                <div className="ef-scroll-ani-inter">
                                    <div className={`bag-box ${isEnter ? 'isEnter' : ''}`}>
                                        <div className="f-img img-one">
                                            <EFPic name={['lakehouse.webp', 'lakehouse.jpg']} />
                                        </div>
                                        <div className="f-img img-two">
                                            <EFPic name={['lakehouse2.webp', 'lakehouse2.jpg']} />
                                        </div>
                                        <div className="f-text">
                                            <div className="f-tip">{t('delta2.aniJ_msg1')}</div>
                                            <div
                                                className="f-title"
                                                style={
                                                    locale === 'fr'
                                                        ? {
                                                              fontSize: '0.3rem',
                                                              lineHeight: '0.36rem',
                                                          }
                                                        : {}
                                                }
                                            >
                                                {t('delta2.aniJ_msg2')}
                                            </div>
                                            <div
                                                className="f-des"
                                                style={
                                                    locale === 'fr'
                                                        ? {
                                                              fontSize: '0.14rem',
                                                              lineHeight: '0.21rem',
                                                          }
                                                        : {}
                                                }
                                            >
                                                {t('delta2.aniJ_msg3')}
                                            </div>
                                            {['cn', 'tw'].includes(locale) && <div className="f-memo">{t('delta2.aniJ_msg4')}</div>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* AU 9.19-9.30 正式开售阶段 */}
                {['au'].includes(locale) && <GotoPage />}
                <FeatApp />
            </div>
        </div>
    );
}
